import { API } from '../../../common/api'
import { labravAWSEngineServiceUrl } from '../../../common/utils/constants'
import { ActionType } from '../../../externalApps/modules/referrals/actions'
import { isEmpty } from 'common/utils/vanilla'

// Salesforce-specific referral submission API
// Uses different endpoint and request body structure than Hubspot
export type SaveReferralAPIParams = {
  object_type: 'opportunity' | 'lead'
  form_status?: 'draft' | 'submitted' // Optional: Don't include when updating already submitted referrals
  referred_by: string
  labra_referral: Record<string, unknown>
  crm_object_id?: string
  cloud_object_id?: string
  parent_object_id?: string
  cloud_type: 'AWS' | 'AZURE' | 'GCP'
  account_id: string
}

// Request body for reject endpoint
export type RejectReferralRequest = {
  labra_referral: {
    Labra__Rejection_reason__c: string
  }
}

//PATCH /partners/{account_id}/referrals/{referral_id}/accept
export const acceptReferral = (partnerId: string, referralId: string) => {
  if (!partnerId || isEmpty(partnerId)) {
    throw new Error('PartnerId is required')
  }
  if (!referralId || isEmpty(referralId)) {
    throw new Error('ReferralId is required')
  }
  const endpointURL = `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/${referralId}/accept`
  return API.patch(endpointURL, {})
}

//PATCH /partners/{account_id}/referrals/{referral_id}/reject
export const rejectReferral = (
  partnerId: string,
  referralId: string,
  data: RejectReferralRequest
) => {
  if (!partnerId || isEmpty(partnerId)) {
    throw new Error('PartnerId is required')
  }
  if (!referralId || isEmpty(referralId)) {
    throw new Error('ReferralId is required')
  }
  const endpointURL = `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/${referralId}/reject`
  return API.patch(endpointURL, data)
}

export const saveReferral = (
  params: SaveReferralAPIParams,
  referralId?: string,
  actionType?: ActionType,
  templateId?: string,
  partnerId?: string
) => {
  // Salesforce-specific endpoint
  // Format: /partners/{partnerId}/referrals or /partners/{partnerId}/referrals/{referralId}
  const endpointURL = partnerId
    ? referralId
      ? `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/${referralId}`
      : `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals`
    : ''

  let method: 'post' | 'put' | 'patch'
  if (actionType === 'put') {
    method = 'put'
  } else if (actionType === 'patch' || referralId) {
    method = 'patch'
  } else {
    method = 'post'
  }
  const requestConfig = {
    method,
    params: {
      template_id: templateId,
    },
    data: params, // Send the params directly without snakeize transformation
  }

  try {
    const response = API(`${endpointURL}`, requestConfig)
    return response
  } catch (error) {
    throw error
  }
}
export const fetchReferral = (partnerId?: string, referralId?: string) => {
  if (!partnerId || isEmpty(partnerId)) {
    throw new Error('PartnerId is required')
  }

  if (!referralId || isEmpty(referralId)) {
    throw new Error('ReferralId is required')
  }

  return API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals/${referralId}`
  )
}
